import {COLORS} from 'frontend/utils/color_palettes';
import {cutSVG} from 'frontend/utils/icons';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const CUT_COLOR = COLORS.NewPrimary.get(40);

export interface CutMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * A map marker for a cut.
 */
export class CutMapMarker extends DefaultMapMarker<CutMapMarkerData> {
  protected override getDefaultIcon(size: IconSize): string {
    return cutSVG(this.data?.color ?? CUT_COLOR, size);
  }
}
